import {action, makeObservable, observable} from 'mobx';

import {Hash} from 'types/hash';
import {RootStore} from 'models/RootStore';
import {InMemoryStore, IStoreData} from 'models/InMemoryStore';
import {StoryPermanentStore} from 'models/story/StoryPermanentStore';
import {IStoryApiData} from 'models/story/IStoryApiData';

export class StoryMemoryStore extends InMemoryStore<IStoryApiData> {
  @observable private _stories: Hash<IStoreData<IStoryApiData>> = {};

  public constructor(rootStore: RootStore) {
    super(rootStore, 'Story');
    makeObservable(this);
  }

  protected get PermanentStore(): StoryPermanentStore {
    return this.StoryPermanentStore;
  }

  public resetAll(): void {
    super.resetAll();
    this._stories = {};
  }

  @action
  public loadFromPermanentStore(id: number): Promise<void> {
    return this.PermanentStore.read(id)
      .then((data: IStoryApiData | null) => {
        if (data) {
          this.set(data);
        }
      });
  }

  @action
  protected setAll(values: IStoryApiData[]): void {
    values.map(value => this.set(value));
  }

  protected getIStoreData(id: number): IStoreData<IStoryApiData> {
    let data: IStoreData<IStoryApiData> = this._stories[id.toString()];
    if (!data) {
      data = new IStoreData<IStoryApiData>(id, null, this);
      this._stories[id.toString()] = data;
    }

    return data;
  }

  @action
  protected set(value: IStoryApiData): void {
    this.getIStoreData(value.id).setData(value);
  }

  @action
  public storeAll(dataArray: IStoryApiData[]): Promise<void[]> {
    return Promise.all(dataArray.map((data: IStoryApiData) => this.store(data)))
  }

  @action
  public store(data: IStoryApiData): Promise<void> {
    this.set(data);
    return this.PermanentStore.store(data);
  }

  public read(id: number): Promise<IStoryApiData | null> {
    return this.getIStoreData(id).LoadData;
  }
}
